import { StandardEvents } from '@shopify/events';

/**
 * Kompatibilitäts-Brücke Horizon 2.x -> 4.x
 *
 * Horizon 4 feuert bei Variantenwechsel und Warenkorb-Änderungen nur noch die Shopify
 * Standard Events (shopify:product:select, shopify:cart:lines-update). Die eigenen
 * Blöcke/Skripte (Sticky-Leiste, Preis-Darstellung, Scroll-zur-Galerie, Warenkorb-Einschub,
 * Wallet-Fit) hören noch auf die früheren Theme-Events. Dieses Skript übersetzt die neuen
 * Events in die alten – mit derselben detail-Struktur wie in Horizon 2.
 *
 *   shopify:product:select    -> variant:selected (sofort), variant:update + variant:change (nach dem Laden)
 *   shopify:cart:lines-update -> cart:update (nach erfolgreicher Änderung)
 */

document.addEventListener(StandardEvents.productSelect, (event) => {
  const target = event.target instanceof EventTarget ? event.target : document;
  const selectDetail = /** @type {any} */ (event).detail || {};

  target.dispatchEvent(
    new CustomEvent('variant:selected', {
      bubbles: true,
      detail: { resource: { id: selectDetail.optionValueId } },
    })
  );

  /** @type {any} */ (event).promise
    ?.then((/** @type {any} */ result) => {
      const detail = result?.detail;
      const variant = detail?.resource;
      if (!variant) return;

      target.dispatchEvent(
        new CustomEvent('variant:update', {
          bubbles: true,
          detail: {
            resource: variant,
            sourceId: detail.sourceId,
            data: { html: detail.html, productId: detail.productId, newProduct: detail.newProduct },
          },
        })
      );

      target.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant } }));
    })
    .catch(() => {});
});

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  const target = event.target instanceof EventTarget ? event.target : document;

  /** @type {any} */ (event).promise
    ?.then((/** @type {any} */ result) => {
      const detail = result?.detail || {};
      if (detail.didError) return;

      target.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: result?.cart ?? null,
            sourceId: detail.sourceId || detail.source || 'standard-event',
            data: { ...detail, itemCount: detail.itemCount ?? result?.cart?.totalQuantity },
          },
        })
      );
    })
    .catch(() => {});
});
